import { __read, __spreadArray } from "tslib";
import { isFunction } from '@dazn/peng-html5-tools-utils';
import { getFeatureIdFromMessageParams } from './getFeatureNameFromMessageParams';
/**
 * A lookup table of all human readable "info", "log", "warning", and "error" messages for
 * debugging. As this type of text is heavy and does not minify well, it is extracted from the
 * default build and loaded as needed as part of the `DebugView`.
 *
 * Logs are still produced regardless at all times, but are stored as terse numeric values which are
 * mapped into their human readable equivalents via this lookup table only when the `DebugView` is
 * activated.
 *
 * NB: This function may be used at run-time for debugging, or at tool-time for arbitrary
 * message parsing. An `errorManager` is provided by the debug feature when used at run-time only.
 */
var renderHumanReadableDebugText = function (messageType, packageNamespace, featureNumber, messageId, args, messages, errorManager) {
    var featureName = '';
    try {
        featureName = getFeatureIdFromMessageParams(packageNamespace, featureNumber, messages);
    }
    catch (_a) {
        errorManager === null || errorManager === void 0 ? void 0 : errorManager.error(6 /* DebugMessageId._006_FEATURE_NAME_NOT_FOUND */, packageNamespace, featureNumber).throw({
            args: [
                ['packageNamespace', String],
                ['featureNumber', Number],
            ],
        });
    }
    var messagesBySeverity = messages[featureName].messages;
    var render = messagesBySeverity[messageType][messageId];
    if (!isFunction(render) && errorManager)
        errorManager
            .error(5 /* DebugMessageId._005_MESSAGE_NOT_FOUND */, messageType, packageNamespace, featureNumber, messageId)
            .throw({
            args: [
                ['messageType', Number],
                ['packageNamespace', String],
                ['featureNumber', Number],
                ['messageId', Number],
            ],
        });
    return render.apply(void 0, __spreadArray([], __read(args), false));
};
export { renderHumanReadableDebugText };
//# sourceMappingURL=renderHumanReadableDebugText.js.map